module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--not-found"
  }, [_c('div', {
    staticClass: "group"
  }, [_c('h1', {
    staticClass: "h1 mb0"
  }, [_vm._v("Uh oh!")]), _vm._v(" "), _c('p', {
    staticClass: "large"
  }, [_vm._v("Page not found…")]), _vm._v(" "), _c('module-button', {
    attrs: {
      "link": _vm.isAuthenticated ? "dashboard" : "home",
      "button": "primary",
      "label": ("Back " + (_vm.isAuthenticated ? "to your dashboard" : "home"))
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d24ed9c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/404.vue
// module id = 227
// module chunks = 0